module.exports = __webpack_public_path__ + "static/media/ca_13.d7bb6cc6.png";